import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './PracticePerfectQuizzes.css';
import Header from '../../Header/Header';
import Spinner from '../../Spinner/Spinner';
import { post } from '../../../app/shared/http';
import { handleException } from '../../../app/util/util';
import loaderColors1 from '../../Spinner/loaderColors1.gif';
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../app/util/HOC";
export function PracticePerfectQuizzes() {
    const { isbn } = useParams();
    const history = useHistory();
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const ppIsbn = (isbn && isbn !== 'undefined') ? isbn : localStorage.getItem('bookIsbn');
    const [ppSummQuizzes, setPpSummQuizzes] = useState({});
    const [ppQuizPageInfo, setPpQuizPageInfo] = useState({});
    const [ppActiveQuizzes, setPpActiveQuizzes] = useState();
    const [isPpQuizPageLoading, setIsPpQuizPageLoading] = useState(true);
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    function getPPQuizPagedetails() {
        let reqData = { "productISBN": ppIsbn };
        post("/PP/get-PPproductDetails", reqData, 'qpAPI')
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data.Exception) {
                    handleException(data);
                    return false;
                } else {
                    if (data.ValidityStatus === "Expired") {
                        localStorage.setItem("PPException", data.ValidityStatus);
                        window.location.replace(window.location.origin + "/invalidUrl");
                        return false;
                    }
                    localStorage.removeItem('PPException');
                    setPpQuizPageInfo(data);
                    getAllSummQuizzes(data.SATagId);
                    localStorage.setItem("ppLandingInfo", JSON.stringify(data));
                    localStorage.setItem("ppProductName", data.ProductName);
                    localStorage.setItem("ppProductTagId", data.SATagId);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function getAllSummQuizzes(ppSubAReaTagId) {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "themisProductId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "themisSubjectAreaId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "ppSubjectAreaTagId": ppSubAReaTagId
                },
                "sessionVO": getSessionVO()
            },
            "ppSubjectAreaTagId": ppSubAReaTagId
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/managePP/getAllSummativeQuizzes`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.ppQuizResultVOList) {
                        data.ppQuizResultVOList = Array.isArray(data.ppQuizResultVOList) ? data.ppQuizResultVOList : [data.ppQuizResultVOList];
                        data.ppQuizResultVOList.map(ppQuiz => {
                            if (ppQuiz.ppSubTopicVOList) {
                                ppQuiz.ppSubTopicVOList = Array.isArray(ppQuiz.ppSubTopicVOList) ? ppQuiz.ppSubTopicVOList : [ppQuiz.ppSubTopicVOList];
                            }
                            if (ppQuiz.ppTopicNames) {
                                ppQuiz.ppTopicNames = Array.isArray(ppQuiz.ppTopicNames) ? ppQuiz.ppTopicNames : [ppQuiz.ppTopicNames];
                            }
                        });
                    }
                    setPpSummQuizzes(data);
                    getActiveQuizzes(ppSubAReaTagId);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function getActiveQuizzes(ppSubAReaTagId) {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "themisProductId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "themisSubjectAreaId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "ppSubjectAreaTagId": ppSubAReaTagId
                },
                "sessionVO": getSessionVO()
            },
            "ppSubjectAreaTagId": ppSubAReaTagId
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/managePP/getActiveQuizzes`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.ppQuizResultVOList) {
                        data.ppQuizResultVOList = Array.isArray(data.ppQuizResultVOList) ? data.ppQuizResultVOList : [data.ppQuizResultVOList];
                        setPpActiveQuizzes(data.ppQuizResultVOList);
                    }
                    setIsPpQuizPageLoading(false);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        getPPQuizPagedetails();
    }, []);
    const handleClickPrevWatchQuiz = () => {
        history.push(`/pp-quiz-center/previously-watched/${ppIsbn}`);
    }
    const handleClickBuiYourQuiz = () => {
        history.push(`/pp-quiz-center/build-your-own/${ppIsbn}`);
    }
    const handleClickCompQuiz = (ppCompQuiz) => {
        localStorage.setItem('ppCompQuizInfo', JSON.stringify(ppCompQuiz));
        history.push(`/pp-quiz-center/comparative/${ppIsbn}`);
    }
    const handleClickActiveQuiz = (ppActiQuiz) => {
        ppActiQuiz.isGraded = "true";
        if (ppActiQuiz.totalQuestions === undefined) {
            ppActiQuiz.totalQuestions = 10;
        }
        localStorage.setItem('quCeGraModeQuizData', JSON.stringify(ppActiQuiz));
        history.push(`/pp-quiz/graded/${ppIsbn}/${ppQuizPageInfo.ProductID}/${ppQuizPageInfo.SATagId +
            (((ppActiQuiz.quizType).toLowerCase() === 'previously watched') ?
                "/previously-watched" : ((ppActiQuiz.quizType).toLowerCase() === 'build your own quiz') ?
                    "/build-your-own" : ((ppActiQuiz.quizType).toLowerCase() === 'summative a' || (ppActiQuiz.quizType).toLowerCase() === 'comparative1') ?
                        "/comparative-a" : ((ppActiQuiz.quizType).toLowerCase() === 'summative b' || (ppActiQuiz.quizType).toLowerCase() === 'comparative2') ?
                            "/comparative-b" : ((ppActiQuiz.quizType).toLowerCase() === 'comparative3') ?
                                "/comparative-c" : ((ppActiQuiz.quizType).toLowerCase() === 'comparative4') ?
                                    "/comparative-d" : ((ppActiQuiz.quizType).toLowerCase() === 'cumulative' || (ppActiQuiz.quizType).toLowerCase() === 'cumulative2') ?
                                        "/comparative-all-topics" : "/comparative")
            }`);
    }
    return (
        <>
            <Spinner
                loading={isPpQuizPageLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <Header userVO={userVO} pageName="PPQuizzes" isbn={ppIsbn}></Header>
            <div className='container'>
                <div className="card ppQuizCenterContainerSection">
                    <div className="card-body ppQuizCenterContainerCard">
                        {
                            isPpQuizPageLoading === false ?
                                <>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div className="ppQuizCenterLogoContainer">
                                                <p>
                                                    <span className='ppQuizCenterCommonStyle ppQuizCenterLogoBoldText'>PracticePerfect<sup>TM</sup></span>
                                                    <span className='ppQuizCenterCommonStyle ppQuizCenterLogoText'>{ppQuizPageInfo.ProductName}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-12'>
                                            <div className='d-flex flex-column justify-content-between flex-md-row flex-lg-row' >
                                                <div className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-4'> Quiz Center</div>
                                            </div>
                                            <p className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1'> Take a Quiz</p>
                                            <p className='ppQuizCenterCommonStyle ppQuizCenterText'>Select a category to test what you've learned </p>
                                            <div className='row'>
                                                {
                                                    ppSummQuizzes.hasPreviouslyWatchedVideos === "true" ?
                                                        <div className='col-xl-3 col-lg-4 col-md-5 col-sm-12 col-12 mb-2' onClick={() => handleClickPrevWatchQuiz()}>
                                                            <div className='ppQuizCenterBoxBorder ppQuizCenterBoxText'>
                                                                <p className='font-weight-bold'>Previously Watched</p>
                                                                <p>Randomized questions from all videos you've watched</p>
                                                            </div>
                                                        </div> : null
                                                }
                                                <div className='col-xl-3 col-lg-4 col-md-5 col-sm-12 col-12 mb-2' onClick={() => handleClickBuiYourQuiz()}>
                                                    <div className='ppQuizCenterBoxBorder ppQuizCenterBoxText'>
                                                        <p className='font-weight-bold'>Build Your Own Quiz</p>
                                                        <p>Select from the full list of topics</p>
                                                    </div>
                                                </div>
                                                <hr className='w-100 mx-3 mb-0 mt-1' />
                                            </div>
                                            {
                                                ppSummQuizzes.ppQuizResultVOList !== undefined ?
                                                    <>
                                                        <p className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1 mt-3'> Comparative Quizzes</p>
                                                        <p className='ppQuizCenterCommonStyle ppQuizCenterText'>Popularly grouped topics to test your knowledge on a broader scale</p>
                                                        <div className='row'>
                                                            {
                                                                ppSummQuizzes.ppQuizResultVOList.map(ppCompQuiz => {
                                                                    return (
                                                                        <div className='col-xl-3 col-lg-4 col-md-5 col-sm-12 col-12 mb-2'>
                                                                            <div className='ppQuizCenterBoxBorder ppQuizCenterBoxText' onClick={() => handleClickCompQuiz(ppCompQuiz)}>
                                                                                <p className='font-weight-bold'>
                                                                                    {
                                                                                        ((ppCompQuiz.quizType).toLowerCase() === 'summative a' || (ppCompQuiz.quizType).toLowerCase() === 'comparative1') ?
                                                                                            `Comparative Quiz A` :
                                                                                            ((ppCompQuiz.quizType).toLowerCase() === 'summative b' || (ppCompQuiz.quizType).toLowerCase() === 'comparative2') ?
                                                                                                `Comparative Quiz B` :
                                                                                                ((ppCompQuiz.quizType).toLowerCase() === 'comparative3') ?
                                                                                                    `Comparative Quiz C` :
                                                                                                    ((ppCompQuiz.quizType).toLowerCase() === 'comparative4') ?
                                                                                                        `Comparative Quiz D` :
                                                                                                        ((ppCompQuiz.quizType).toLowerCase() === 'cumulative' || (ppCompQuiz.quizType).toLowerCase() === 'cumulative2') ?
                                                                                                            `Comparative Quiz: All Topics` : null
                                                                                    }
                                                                                </p>
                                                                                {
                                                                                    (ppCompQuiz.quizType === 'Cumulative' || ppCompQuiz.quizType === 'Cumulative2') ?
                                                                                        <p>All topics in {ppQuizPageInfo.ProductID === 1 ? `Civil Procedure` : `Torts`} </p> :
                                                                                        <p className='ppQuizCenterBoxText'>
                                                                                            Questions from {
                                                                                                ppCompQuiz.ppTopicNames.map((ppCompQuizTopic, index) => {
                                                                                                    return (
                                                                                                        ppCompQuizTopic +
                                                                                                        (index === ppCompQuiz.ppTopicNames.length - 2 ? " and " : "") +
                                                                                                        (index <= ppCompQuiz.ppTopicNames.length - 3 ? ", " : "")
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </p>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                            <hr className='w-100 mx-3 mb-0 mt-1' />
                                                        </div>
                                                    </> : null
                                            }
                                            {
                                                ppActiveQuizzes !== undefined ?
                                                    <>
                                                        <p className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1 mt-3'> Active Quizzes</p>
                                                        <p className='ppQuizCenterCommonStyle ppQuizCenterText'>Quizzes you started but haven't submitted yet</p>
                                                        <div className='row'>
                                                            {
                                                                ppActiveQuizzes.map((ppActiQuiz, index) => {
                                                                    return (
                                                                        <div key={index} className='col-xl-3 col-lg-4 col-md-5 col-sm-12 col-12 mb-2'
                                                                            onClick={() => handleClickActiveQuiz(ppActiQuiz)}>
                                                                            <div className='ppQuizCenterBoxBorder ppQuizCenterBoxText'>
                                                                                <p className='font-weight-bold'>
                                                                                    {
                                                                                        ((ppActiQuiz.quizType).toLowerCase() === 'summative a' || (ppActiQuiz.quizType).toLowerCase() === 'comparative1') ?
                                                                                            `Comparative Quiz A: Quiz ` :
                                                                                            ((ppActiQuiz.quizType).toLowerCase() === 'summative b' || (ppActiQuiz.quizType).toLowerCase() === 'comparative2') ?
                                                                                                `Comparative Quiz B: Quiz ` :
                                                                                                ((ppActiQuiz.quizType).toLowerCase() === 'comparative3') ?
                                                                                                    `Comparative Quiz C: Quiz ` :
                                                                                                    ((ppActiQuiz.quizType).toLowerCase() === 'comparative4') ?
                                                                                                        `Comparative Quiz D: Quiz ` :
                                                                                                        ((ppActiQuiz.quizType).toLowerCase() === 'cumulative' || (ppActiQuiz.quizType).toLowerCase() === 'cumulative2') ?
                                                                                                            `Comparative Quiz: All Topics: Quiz ` : (ppActiQuiz.quizType + ': Quiz ')
                                                                                    }{ppActiQuiz.quizAttempt}
                                                                                </p>
                                                                                <p>
                                                                                    {
                                                                                        ppActiQuiz.totalQuestions === undefined ? `10 Questions` :
                                                                                            (ppActiQuiz.totalQuestions + (Number(ppActiQuiz.totalQuestions) > 1 ? ` Questions` : ` Question`))
                                                                                    }, {
                                                                                        ppActiQuiz.quizTiming === '300' ? `Unlimited Time` :
                                                                                            (ppActiQuiz.quizTiming + (Number(ppActiQuiz.quizTiming) > 1 ? ` Minutes` : ` Minute`))
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                            <hr className='w-100 mx-3 mb-0 mt-1' />
                                                        </div>
                                                    </>
                                                    : null
                                            }
                                        </div>
                                    </div>
                                </>
                                : null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default withAuth(PracticePerfectQuizzes);